export const AppRoutePath = {
	Home: Symbol('Home'),
	Tours: Symbol('Tours'),
	Reservation: Symbol('Reservation'),
	Hotels: Symbol('Hotels'),
	AboutUs: Symbol('AboutUs'),
	LastMinute: Symbol('LastMinute'),
	FirstMinute: Symbol('FirstMinute'),
	Partners: Symbol('Partners'),
	FlightInformation: Symbol('FlightInformation'),
	ComingSoon: Symbol('ComingSoon'),
	AboutCyprus: Symbol('AboutCyprus'),
	Premium: Symbol('Premium'),
	SpecialOffer: Symbol('SpecialOffer'),
};
